import styled from '@emotion/styled';
import { Colors, Icon } from '@zapier/design-system';
import React from 'react';

type Props = {
  children: React.ReactNode;
};

export const ErrorMessage = ({ children }: Props) => {
  return (
    <Error>
      <Icon name="formXCircle" color="red500" />
      <Message>{children}</Message>
    </Error>
  );
};

export const SuccessMessage = ({ children }: Props) => {
  return (
    <Success>
      <Icon name="formCheckCircle" color="green500" />
      <Message>{children}</Message>
    </Success>
  );
};

const Wrapper = styled.div`
  border: 1px solid black;
  border-radius: 10px;
  display: grid;
  grid-column-gap: 10px;
  grid-template-columns: max-content 1fr;
  justify-content: center;
  align-items: center;
  padding: 10px 15px;
  margin: 0 10px;
`;

const Message = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
`;

const Success = styled(Wrapper)`
  border-color: ${Colors.green500};
  background-color: ${Colors.green100};
`;

const Error = styled(Wrapper)`
  border-color: ${Colors.red500};
  background-color: ${Colors.red100};
`;
